var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBox20(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 34",
    d: "M0.588379 4.121L8.82367 0.611816L19.4119 2.95127L12.3531 7.63018L0.588379 4.121Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 35",
    d: "M0.588379 14.6485V4.12097L12.3531 7.63015V19.3274L0.588379 14.6485Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 36",
    d: "M12.3532 19.3274V7.63008L19.412 2.95117V13.4787L12.3532 19.3274Z",
    fill: "#222627"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 303 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.76607 0L20 2.48212V13.7528L12.4601 20L0 15.0445V3.73535L8.76607 0ZM8.88099 1.22365L2.30957 4.02383L12.2569 6.99093L17.9385 3.2249L8.88099 1.22365ZM18.8235 4.04411L12.9412 7.9432V18.0788L18.8235 13.2049V4.04411ZM11.7647 18.4636V8.06535L1.17647 4.90708V14.2526L11.7647 18.4636Z",
    fill: "#222627"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox20);
export default __webpack_public_path__ + "static/media/box_20.c915b1c53f88d81c7d760128c9810087.svg";
export { ForwardRef as ReactComponent };